import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["childTable", "toggleButton"];

  toggleTable(event) {
    const button = event.currentTarget;
    const tableId = button.dataset.tableId;
    const tableType = button.dataset.tableType;
    const childTable = document.getElementById(`${tableType}-table-${tableId}`);
    
    if (childTable.classList.contains('hidden')) {
      childTable.classList.remove('hidden');
      button.textContent = `Close ${this.capitalizeFirstLetter(tableType)}`;
    } else {
      childTable.classList.add('hidden');
      button.textContent = `View ${this.capitalizeFirstLetter(tableType)}`;
    }
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
